import { datesFirstCaps } from "../../constants/dates";
import { getEasternTime } from "../../helpers/dateHelpers";

const DAY_NAMES= ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const DEFAULT_MANAGE_REQUESTS_ROWS = [
    { id: 0, pilot: '-', seniority: '-', datesRequested: '-', status: '-', monthYear: '-'},
    { id: 1, pilot: '', seniority: '', datesRequested: '', status: '', monthYear: ''},
];

export const DEFAULT_MANAGE_REQUESTS_SEARCH_PARAMS = {
    pilotAutocompleteId: '',
    pilotAutocompleteValue: '',
    sdoDate: 'All',
    sdoPosition: 'All Positions',
    searchClicked: false
}

export const requestStatusType = {
    APPROVED: 'APPROVED' || 'Approved',
    CONFLICT: 'CONFLICT',
    DECLINED: 'DECLINED',
    EXCEPTION: 'EXCEPTION',
    SUBMITTED: 'SUBMITTED',
    REVOKED: 'REVOKED',
};

export const formatDatesRequested = (startDate: Date, endDate: Date, days: number) => {
    const daysText = days > 1 ? 'Days' : 'Day'
    return `${formatDate(startDate)} - ${formatDate(endDate)} (${days} ${daysText})`;
}

const getTwoDigits = (param) => param < 10 ? ('0' + param) : param;

export const formatDatesRequestedOn = (requestedOn: string) => {
    const date = getEasternTime(requestedOn);
    const time = `${getTwoDigits(new Date(date).getHours())}:${getTwoDigits(new Date(date).getMinutes())}`;
    //const date = new Date(requestedOn.split(' ')[0]);
    //const time = requestedOn.split(' ')[1];
    return `${formatDate(new Date(date))} at ${time}`
} 

const formatDate = (date: Date) => {
    const day = DAY_NAMES[date.getDay()];
    const dayNumber = date.getDate();
    const month = datesFirstCaps[date.getMonth()];

    return `${day}, ${month} ${dayNumber}`;
}

export const getCreatedOn = () => {
    const year = getEasternTime().getFullYear();
    const month = getEasternTime().getMonth()+1 < 10 ? `0${getEasternTime().getMonth()+1}` : getEasternTime().getMonth()+1;
    const date = getEasternTime().getDate() < 10 ? `0${getEasternTime().getDate()}` : getEasternTime().getDate();
    const time = getEasternTime().toLocaleString('en-US', {hour12: false}).split(' ')[1];
    const createdOn = `${year}/${month}/${date} ${time}`;
    return createdOn; 
}

export const sortDataRows = (v1, v2) => {
    return sortMonthYearComparator(v2.monthYear, v1.monthYear);
}

export const sortMonthYearComparator = (v1, v2) => {
    return new Date(v1.year, v1.month, v1.date).getTime() - new Date(v2.year, v2.month, v2.date).getTime();
}

export const sortSdoDateComparator = (v1, v2) => {
    return new Date(v2.sdoYear, v2.sdoMonth).getTime() - new Date(v1.sdoYear, v1.sdoMonth).getTime();
}

export const sortDateComparator = (v1, v2) => {
    return new Date(v1.startDate).getTime() - new Date(v2.startDate).getTime();
}

export const sortPilotNameComparator = (v1, v2) => {
    if(!v1) return;
    return v1.name.localeCompare(v2.name);
}

export const sortRequestedOnComparator = (v1, v2) => {
    return new Date(v1.date).getTime() - new Date(v2.date).getTime();
}

export const sortStatusComparator = (v1, v2) => {
    return v1.label.localeCompare(v2.label);
}

 /**
  * Returns TRUE if "All Positions" were selected which resulted in empty base value or undefined
  * @function
  * @param {Object} selectedPosition - selectedPosition object containing base value
  * @returns {Boolean} : True if base is undefined or empty else false
  */
export const isPositionBaseEmpty = (selectedPosition) => {
    const  base = selectedPosition?.pos[0]?.base; 
    return base === 'undefined' || !base;
}